export default "__VITE_ASSET__CeBOigMP__"